export default key => {
  let value = defaults[key];
  if (typeof window !== "undefined") {
    value =
      window.config && window.config[key] !== undefined
        ? window.config[key]
        : defaults[key];
  }
  return value;
};

const defaults = {
  API_URL: "http://localhost:3000/api/",
  TICKETING_URL: "http://localhost:8080",
  WEBSITE_URL: "http://localhost:7070",
  CONSOLE_URL: "http://localhost:3001",
  BPOINT_API_URL: "https://www.bpoint.com.au/webapi/v3/",
  SENTRY_ERROR_ACCESS_APP: null,
  GOOGLE_API_KEY: "AIzaSyBrLKaAEokK10u3KCRKI0WJyXUN6iAT6AI",
  NODE_ENV: "staging",
  DEV: true,
  PAYPAL_ENV: "production",
  STRIPE_APK_KEY: "pk_test_xtsRcoIILJ6EWSxRgSEgnosm",
  STRIPE_PAYMENTS_APK_KEY: "pk_test_xtsRcoIILJ6EWSxRgSEgnosm",
  CURRENCY: "AUD",
  ZIPMONEY_LIBARY_URL:
    "https://static.zipmoney.com.au/checkout/checkout-v1.min.js",
  ZIPMONEY_ENV: "sandbox",
  ORDER_COMPLETE_TIME: 20,
  GOOGLE_API_KEY: "AIzaSyBrLKaAEokK10u3KCRKI0WJyXUN6iAT6AI",
  FILESTACK_KEY: "AeJa0mS9cRHyQaj6WeE3yz",
  TAX_NAME: "ABN",
  REDIRECT_TIME: 7000
};



// WEBPACK FOOTER //
// ./config.js